import { render, staticRenderFns } from "./CourseView.vue?vue&type=template&id=7e745c58&scoped=true"
import script from "./CourseView.vue?vue&type=script&lang=js"
export * from "./CourseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e745c58",
  null
  
)

export default component.exports